import React from 'react';
import UserFlyoutContent from '@header/scripts/components/user/UserFlyoutContent.jsx';

export default function UserFlyout({userStatus, texts, links, closeFlyout}) {
    return (
        <div className="header__my-account-flyout">
            <UserFlyoutContent userStatus={userStatus} texts={texts} links={links} closeFlyout={closeFlyout} />
        </div>
    );
}
